// extracted by mini-css-extract-plugin
export var dateLabel = "_3y-0";
export var dateLabelError = "_3y-1";
export var fullWidth = "_3y-2";
export var smaller = "_3y-3";